import NumericInputGroup from './NumericInputGroup';

export default NumericInputGroup;
